import React from "react";
import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";

// import { AxiosError } from "axios";

interface ErrorPageProps {
  error: any;
}

const ErrorPage: React.FC<ErrorPageProps> = ({ error }) => {
  const navigate = useNavigate();

  return (
    <Result
      status={500}
      title="Error !"
      subTitle="Sorry, there is some error at the moment. Please try again later."
      extra={
        <Button
          type="primary"
          onClick={() => navigate("/")}
          className="h-12 px-4  border border-2 border-border text-base   gap-2 bg-primary text-white border-none "
        >
          Back Home
        </Button>
      }
    />
  );
};

export default ErrorPage;
